export default "__VITE_ASSET__9fef41c4__"